import { WIDGET } from '../../constants/entityTypes';
import { UPDATE, DELETE } from '../../constants/actionsTypes';
import ChangeModel from '../../models/ChangeModel';
import changesQueueInstance from '../ChangesQueue';

class WidgetChangeManager {
  changesQueue: typeof changesQueueInstance;
  entityType: string;

  constructor(changesQueue) {
    this.changesQueue = changesQueue;
    this.entityType = WIDGET;
  }

  update(beforeUpdate, afterUpdate) {
    const change = new ChangeModel(
      this.entityType,
      UPDATE,
      beforeUpdate,
      afterUpdate,
      null,
    );
    return this.changesQueue.addChange(change);
  }

  delete(entity) {
    const change = new ChangeModel(this.entityType, DELETE, entity, null);

    return this.changesQueue.addChange(change);
  }
}

export default new WidgetChangeManager(changesQueueInstance);
